export default "__VITE_PUBLIC_ASSET__72ebe558__"